import React from 'react';
import './CircularLoader.less';

export default function CircularLoader() {
  return (
    <div className="loading_icon circular-loader">
      <div className="css-icon" />
    </div>
  );
}
